import { Libraries } from '@react-google-maps/api/dist/utils/make-load-script-url';
import mapStyles from './mapStyles';

export const CHOOSE_SURVEY_MAP_CONFIG = {
	libraries: ['places'] as Libraries,

	mapContainerStyle: {
		height: '300px',
		width: '100%',
		borderRadius: '4px',
		border: '10px solid white',
	},

	options: {
		styles: mapStyles,
		disableDefaultUI: true,
		zoomControl: true,
		minZoom: 2,
		panControl: true,
	},

	center: {
		lat: 0,
		lng: 0,
	},
};
